export default "__VITE_ASSET__8eead967__"